module.exports = __webpack_public_path__ + "img/DSC_0090.955f1cf6.jpg";